export default __webpack_public_path__ + "static/media/SCANIA_HABITOS_DE_CONDUCCION_AUTOBUSES.a0aee36a.pdf";